module.exports = __webpack_public_path__ + "img/CI.c80d1db0.png";